// eslint-disable-next-line
export const SERVICES = process.env.REACT_APP_SERVICES;
export const BS_UI = process.env.REACT_APP_BS_UI as string;
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY as string;

export default {
    SERVICES,
    BS_UI,
};
